module.exports = __webpack_public_path__ + "img/bucket_driving.96663444.svg";